'use strict';


export default function routes($stateProvider) {
  'ngInject';
  $stateProvider
    .state('main', {
      url: '/appbuilder',
      template: '<main></main>'
    });
};



// WEBPACK FOOTER //
// ./client/app/main/main.routes.ts